module.exports = __webpack_public_path__ + "static/media/crown1.c5334712.svg";